/** @jsxImportSource @emotion/react */
import React, { FC, useEffect } from 'react';
import { Close } from '@mui/icons-material';
import {
  css,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useDialog } from 'hooks/useDialog';

const Settings: FC = () => {
  const theme = useTheme();
  const { openDialog, handleOpenDialog, handleCloseDialog } = useDialog();

  const buildVersion = process.env.REACT_APP_VERSION || '0.0.0';

  useEffect(() => {
    const webApp = Telegram.WebApp;
    webApp.SettingsButton.show();
    webApp.SettingsButton.onClick(handleOpenDialog);

    return () => {
      webApp.SettingsButton.offClick(handleOpenDialog);
      webApp.SettingsButton.hide();
    };
  }, [handleOpenDialog]);

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      fullWidth
      fullScreen
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
        },
      }}
    >
      <DialogTitle
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <Typography variant="inherit" />

        <IconButton color="primary" size="small" onClick={handleCloseDialog}>
          <Close fontSize="inherit" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={4} height="100%" justifyContent="space-between">
          <Stack spacing={4} />

          <Stack spacing={1}>
            <Divider
              css={css`
                border-color: ${theme.palette.primary.dark};
              `}
            />
            <Typography
              css={css`
                opacity: 0.7;
              `}
            >
              Version: {buildVersion}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default Settings;
